import React, {useEffect} from "react";

const RestartTable = (props) => {
  const {stats_data
  } = props


  if (stats_data.restart_dev_data.length === 0) return <p>.......</p>

  const dataArray = stats_data.restart_dev_data;

  const valueDecorate = (i) => {

  }

  return (
    <>

   <h5>Restart Stats</h5>
    <table className="table table-striped">
    <thead>
      <tr className="text-secondary">
        {Object.entries(dataArray[0]).map((el,i) => <th key={i}>{el[0]}</th>)}
      </tr>
    </thead>
    <tbody>
        {dataArray.map((item, y) => (
            <tr key={y}>
                {Object.entries(item).map((v,i) => 
                <td key={i} className={`${i === 0 ? 'font-weight-bold': ''}`}>
                  {`${(v[1] != 0)? v[1]:'-'}`}
                </td>
                )}
            </tr>
        ))}
    </tbody>
    </table>

{/*         <div className="container mt-5">
          <h2>Event Records</h2>
          <table className="table table-striped">
              <thead>
                  <tr>
                      <th>ID</th>
                      <th>Dev ID</th>
                      <th>Code</th>
                      <th>description</th>
                      <th>Data Created</th>
                  </tr>
              </thead>
              <tbody>
                  {data.map((item) => (
                      <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.dev_id}</td>
                          <td>{item.code}</td>
                          <td>{item.description}</td>
                          <td>{new Date(item.date_created).toLocaleString()}</td>
                      </tr>
                  ))}
              </tbody>
          </table>
      </div> */}
    </>
  )
}


export default RestartTable;